<i class="material-icons gem-help-icon" [ngbTooltip]="tooltip" placement="top" container="body">help_outline</i>
